import { atomFamily } from "recoil";

export const iconState = atomFamily({
	key: "icon",
	default: null,
	effects_UNSTABLE: (name) => [
		({ setSelf }) => {
			if (!name) {
				return;
			}
			const isServer = typeof window === "undefined";
			try {
				// Allows us to handle builds
				if (isServer) {
					const iconData = require(`../../../../_assets/icons/${name}.svg`).default;
					if (typeof iconData === "string") {
						const string = iconData.replace(/data:image\/[^;]+;base64,/, "");
						setSelf(Buffer.from(string, "base64").toString());
						return;
					}
				}
				import(`../../../../_assets/icons/${name}.svg`)
					.then(response => {
						fetch(response.default)
							.then((response) => {
								response
									.text()
									.then((svgData) => {
										const newEl = document.createElement("div");
										newEl.innerHTML = svgData;
										const svgEl = newEl.firstChild;
										setSelf(svgEl);
									})
									.catch((e) => {
										throw e;
									});
						}).catch(e => {
							throw e
						})

					})
					.catch((e) => {
						throw e;
					});
			} catch (e) {
				throw e;
			}
		},
	],
});
